import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { X, Loader2, Download } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { SUPABASE_URL } from '@/config/eveBackend';

interface TermsOfServiceModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const TermsOfServiceModal: React.FC<TermsOfServiceModalProps> = ({ isOpen, onClose }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // The PDF URL is now directly accessible from the public bucket
  const pdfUrl = `${SUPABASE_URL}/storage/v1/object/public/figabl//250404%20Figabl%20Online%20Master%20Services%20Agreement.pdf`;

  const downloadTermsDocument = () => {
    // Create a link element and trigger download
    const a = document.createElement('a');
    a.href = pdfUrl;
    a.download = 'Figabl Online Master Services Agreement.pdf';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-4xl h-[80vh] flex flex-col">
        <DialogHeader className="flex flex-row items-center justify-between">
          <DialogTitle>Terms of Service and Privacy Policy</DialogTitle>
          <Button variant="ghost" size="icon" onClick={downloadTermsDocument} title="Download document">
            <Download className="h-4 w-4" />
          </Button>
        </DialogHeader>

        <div className="flex-grow overflow-hidden mt-4 rounded-md bg-gray-50">
          <iframe
            src={pdfUrl}
            className="w-full h-full border-0"
            title="Terms of Service Document"
          />
        </div>

        <div className="flex justify-end mt-4">
          <Button onClick={onClose}>Close</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TermsOfServiceModal;
